module.exports = __webpack_public_path__ + "img/c2.1b4a0139.png";